export const SelectedSiteIdMixin = {
  computed: {
    selectedSiteId () {
      return this.$route.query.siteId || this.$route.query.siteid || ''
    }
  }
}
